import React, { useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import SearchNav from "./function-components/Searchnav";
import Navbarmenu from "./function-components/Navbarmenu";
import Footer from "./function-components/Footer";
import Home from "./pages/Home";
import FAQ from "./pages/FAQ";
import AboutQA from "./pages/AboutQA";
// import QALKM from "./pages/QALKM";
import QAOrganization from "./pages/QAOrganization";
import Track from "./pages/Track";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "./PageLayout";
import ProcessTemplates from "./function-components/ProcessTemplatesContent";
import ProcessFlow from "./pages/ProcessFlow"
import Audit from './pages/Audit';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import AnalyticsPage from "./function-components/AnalyticsPage";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
   
    if (activeAccount) {
    
      fetchAccessToken()
   
    }
  }, [activeAccount]);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    try {
     
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount
      });
      const bearer = `Bearer ${response.accessToken}`;
   
      localStorage.setItem("token", bearer)
   
    }
    catch (error) {
      console.error('Error fetching access token:', error);
      localStorage.clear()
    }
  };
  return (
    <>
      <Router basename={"/QA"}>
        <SearchNav />
        <Navbarmenu />
        <Switch>
          <Route exact path="/home">
            <Home />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/aboutQA">
            <AboutQA />
          </Route>
          {/* <Route exact path="/qa@lkm">
            <QALKM/>
          </Route> */}
          <Route exact path="/process&Templates">
            <ProcessTemplates />
          </Route>
          <Route exact path="/tracks">
            <Track />
          </Route>
          <Route path="/tracks/delivery/technology">
            <Track />
          </Route>
          <Route path="/tracks/techversant/technology">
            <Track />
          </Route>
          <Route path="/tracks/operations/technology">
            <Track />
          </Route>
          <Route path="/tracks/cloud/technology">
            <Track />
          </Route>
          <Route path="/tracks/learning/technology">
            <Track />
          </Route>
          <Route path="/tracks/tower/technology">
            <Track />
          </Route>
          <Route exact path="/QAstructure">
            <QAOrganization />
          </Route>
          <Route exact path="/ProcessFlow">
            <ProcessFlow />
          </Route>
          <Route exact path="/faq">
            <FAQ />
          </Route>
          <Route exact path="/audit">
            <Audit />
          </Route>
          <Route exact path="/Analytics">
            <AnalyticsPage/>
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;
